import { Box, Typography, useTheme } from "@mui/material"

const TextInfoTicket = ({titulo, descripcion, onClick}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                mb: 1,
                gap: 2
            }}
            key={titulo}
        >
            <Typography sx={{
                color: isDarkMode ? '#b0bec5' : '#2c3e50',
                fontWeight: 600,
                fontSize: 12,
                minWidth: 'fit-content',
                flexShrink: 0
            }}>
                {titulo}:
            </Typography>
            <Typography
                onClick={onClick}
                sx={{
                    color: onClick ? (isDarkMode ? '#90caf9' : '#0364ff') : (isDarkMode ? '#e0e0e0' : '#5d6b82'),
                    fontWeight: 500,
                    fontSize: 12,
                    textAlign: 'right',
                    cursor: onClick ? 'pointer' : 'default',
                    wordBreak: 'break-word',
                    flex: 1,
                    '&:hover': onClick ? {
                        textDecoration: 'underline'
                    } : {}
                }}
                component='div'
            >
                {descripcion || '-'}
            </Typography>
        </Box>
    )
}

export default TextInfoTicket
